<template lang="pug">
v-main
  v-container(fluid)
    v-flex
      v-card
        v-toolbar.elevation-0(color="white")
          v-toolbar-title(v-model="title") {{ title }}
          v-spacer
          v-btn(dark, color="blue-secondary", to="/blocked-email/create" class="elevation-0") CREATE
        v-divider
        v-toolbar.elevation-0.mt-2.mb-4(color="white")
          v-text-field.hidden-sm-and-down.col-12(
            flat,
            append-icon="search",
            placeholder="Keyword (optional)",
            v-model="keyword",
            hide-details
          )
        v-divider
        v-card-text.pa-0
          v-data-table(
            :headers="dataHeaders",
            :items="dataItems",
            :search="keyword"
          )
            template(v-slot:item.data-table-expand="{ headers, item }")
              v-icon.mr-2(
                title="edit",
                color="green",
                @click="onEdit(item._id)"
              )
                | edit

            template(v-slot:no-data)
              div.pa-15 
                img(src="../assets/icon/empty-users.png")
                div(class="empty__title mt-1") Data not found
                div(class="empty__subtitle") Data is empty or Try adjusting your filters.

            template(v-slot:no-results)
              div.pa-15 
                img(src="../assets/icon/empty-users.png")
                div(class="empty__title mt-1") Data not found
                div(class="empty__subtitle") Data is empty or Try adjusting your filters.
</template>

<script>
import axios from "axios";
export default {
  name: "BlockedEmailList",
  components: {},
  props: {
    title: String,
  },
  data() {
    return {
      keyword: "",
      dataStatus: ["All", "Active", "Non Active"],
      group: ["All", "Admin", "User"],
      business_unit: [],
      dataHeaders: [
        { text: "Domain Email Name", value: "domain" },
        { text: "Created Date", value: "createdAt" },
        { text: "Updated Date", value: "updatedAt"},
        { text: "Is Blocked", value: "isBlocked"},
        { text: "Actions", value: "data-table-expand" },
      ],
      dataItems: [],
      isSuperAdmin: false,
      users: [],
      status: "",
    };
  },
  mounted() {
    this.isSuperAdmin = this.$store.state.dataUsers.role;
    this.getDataUsers(this.isSuperAdmin);
  },
  methods: {
    getDataUsers: function (isSuperAdmin) {
      let token = localStorage.getItem("token");

      function formatDate(date) {
        if (!(date instanceof Date)) {
          date = new Date(date);
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
      }

      axios
        .post(process.env.VUE_APP_API + `/blocked-email/list`, {}, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          res.data.data.forEach((data) => {
            data.createdAt = formatDate(data.createdAt);
            data.updatedAt = formatDate(data.updatedAt);
            data.isBlocked = (data.isBlocked) ? 'Yes' : 'No';
          });
          this.dataItems = res.data.data;
        })
        .catch((err) => {
          this.$toaster.error(err, { icon: "error" });
        })
        .finally(() => (this.loading = false));
    },
    onEdit(item) {
      this.$router.push({
        name: "Blocked Email Edit",
        params: { id: item },
      });
    },
    statusFilter(val) {
      if (this.status == "All") {
        return true;
      }

      if (!this.status) {
        return true;
      }
      return val === this.status;
    },
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>
